(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRipple() {
    document.querySelectorAll('.pq-btn').forEach(function (btn) {
      if (btn.dataset.pqRipple) return;
      btn.dataset.pqRipple = '1';
      btn.addEventListener('pointerdown', function (e) {
        if (reduced) return;
        var r = btn.getBoundingClientRect(), size = Math.max(r.width, r.height) * 2.2;
        var el = document.createElement('span');
        el.className = 'pq-ripple';
        el.style.width = el.style.height = size + 'px';
        el.style.left = (e.clientX - r.left - size / 2) + 'px';
        el.style.top = (e.clientY - r.top - size / 2) + 'px';
        btn.appendChild(el);
        el.addEventListener('animationend', function () { el.remove(); });
      });
    });
  }

  function initBuybar() {
    document.querySelectorAll('.pq-buybar').forEach(function (bar) {
      if (bar.dataset.pqInit) return;
      bar.dataset.pqInit = '1';
      // umbral 0 = barra visible desde que se abre la página
      if (bar.dataset.umbral === '0') { bar.classList.add('pq-show'); return; }
      var factor = parseFloat(bar.dataset.umbral) || 1.2;
      var umbral = factor * window.innerHeight, visible = false;
      window.addEventListener('resize', function () { umbral = factor * window.innerHeight; });
      window.addEventListener('scroll', function () {
        var pasa = window.scrollY > umbral;
        if (pasa !== visible) { visible = pasa; bar.classList.toggle('pq-show', pasa); }
      }, { passive: true });
    });
  }

  function initCalc() {
    document.querySelectorAll('.pq-calc__card').forEach(function (card) {
      if (card.dataset.pqInit) return;
      card.dataset.pqInit = '1';
      var margen = (parseFloat(card.dataset.margen) || 40) / 100;
      var get = function (k) { return card.querySelector('[data-campo="' + k + '"]'); };
      var oCosto = card.querySelector('[data-salida="costo"]'), oPrecio = card.querySelector('[data-salida="precio"]');
      var n = function (k) { var el = get(k); var v = el ? parseFloat(el.value) : 0; return isFinite(v) && v > 0 ? v : 0; };
      var fmt = function (v) { return '$' + Math.round(v).toLocaleString('es-AR'); };
      var calc = function () {
        var uni = Math.max(1, n('uni'));
        var total = n('ing') + n('pack') + n('gas') + n('hs') * n('vh');
        var costo = total / uni;
        oCosto.textContent = fmt(costo);
        oPrecio.textContent = fmt(Math.ceil(costo * (1 + margen) / 50) * 50);
      };
      card.querySelectorAll('input').forEach(function (i) { i.addEventListener('input', calc); });
      calc();
    });
  }

  function initTracks() {
    document.querySelectorAll('[data-pq-track]').forEach(function (wrap) {
      if (wrap.dataset.pqInit) return;
      wrap.dataset.pqInit = '1';
      var track = wrap.querySelector('.pq-track'), sbar = wrap.querySelector('.pq-scrollbar'), thumb = wrap.querySelector('.pq-thumb');
      if (!track || !sbar || !thumb) return;
      var sync = function () {
        var max = track.scrollWidth - track.clientWidth;
        var w = Math.max(track.clientWidth / track.scrollWidth * 100, 10);
        thumb.style.width = w + '%';
        thumb.style.left = ((max ? track.scrollLeft / max : 0) * (100 - w)) + '%';
      };
      var seek = function (x) {
        var r = sbar.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (x - r.left) / r.width));
        track.scrollLeft = p * (track.scrollWidth - track.clientWidth);
      };
      sbar.addEventListener('pointerdown', function (e) { sbar.classList.add('pq-dragging'); sbar.setPointerCapture(e.pointerId); seek(e.clientX); });
      sbar.addEventListener('pointermove', function (e) { if (sbar.classList.contains('pq-dragging')) seek(e.clientX); });
      ['pointerup', 'pointercancel'].forEach(function (ev) { sbar.addEventListener(ev, function () { sbar.classList.remove('pq-dragging'); }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', function () { requestAnimationFrame(sync); });
      sync();
    });
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('pq-in');
      if (e.target.dataset.pqCount) countUp(e.target);
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function countUp(el) {
    var fin = parseInt(el.dataset.pqCount, 10), t0 = null;
    var step = function (t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / 1100);
      el.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  function initReveal() {
    var html = document.documentElement;
    if (reduced || !io) { html.classList.remove('pq-js'); return; }
    html.classList.add('pq-js');
    var marcar = function (el, d) {
      if (el.dataset.pqRv) return;
      el.dataset.pqRv = '1';
      el.classList.add('pq-rv');
      if (d) el.style.setProperty('--rv-d', d + 's');
      io.observe(el);
    };
    // v10: sin "aparecer al bajar" (pedido de Joaquín: contenido estático). marcar() queda por si se vuelve a usar.
    void marcar;
    document.querySelectorAll('.pq-price-old').forEach(function (el) { if (!el.dataset.pqRv) { el.dataset.pqRv = '1'; io.observe(el); } });
    if (!html.dataset.pqRvSafe) {
      html.dataset.pqRvSafe = '1';
      var pend = false;
      window.addEventListener('scroll', function () {
        if (pend) return;
        pend = true;
        setTimeout(function () {
          pend = false;
          document.querySelectorAll('.pq-rv:not(.pq-in)').forEach(function (el) {
            if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('pq-in'); io.unobserve(el); }
          });
        }, 250);
      }, { passive: true });
    }
    document.querySelectorAll('.pq-stamp b').forEach(function (b) {
      var n = parseInt(b.textContent, 10);
      if (n > 0 && !b.dataset.pqCount) { b.dataset.pqCount = n; b.textContent = '0'; io.observe(b); }
    });
  }

  function initBgVideo() {
    document.querySelectorAll('video[data-pq-bg]').forEach(function (v) {
      if (v.dataset.pqInit) return;
      v.dataset.pqInit = '1';
      var con = navigator.connection;
      if (reduced || (con && (con.saveData || /2g/.test(con.effectiveType || '')))) return;
      var cargar = function () {
        v.src = window.matchMedia('(min-width: 750px)').matches ? v.dataset.desk : v.dataset.movil;
        v.muted = true;
        v.addEventListener('playing', function () { v.classList.add('pq-on'); }, { once: true });
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };
      if (document.readyState === 'complete') setTimeout(cargar, 300);
      else window.addEventListener('load', function () { setTimeout(cargar, 300); }, { once: true });
    });
  }

  // Paso "antes de pagar": intercepta los botones que llevan al pago del ebook y ofrece sumar packs
  function initBump() {
    var box = document.querySelector('[data-pq-bump]');
    if (!box || box.dataset.pqInit) return;
    box.dataset.pqInit = '1';
    if (box.parentElement !== document.body) document.body.appendChild(box);
    var base = box.dataset.base, combo = box.dataset.combo;
    var ops = [].slice.call(box.querySelectorAll('[data-pq-bump-op]'));
    var ir = box.querySelector('[data-pq-bump-ir]'), solo = box.querySelector('[data-pq-bump-solo]');
    var totalEl = box.querySelector('[data-pq-bump-total]'), comboEl = box.querySelector('[data-pq-bump-combo]');
    var query = '', ultimo = null;
    var fmt = function (c) { return '$' + Math.round(c / 100).toLocaleString('es-AR'); };
    var armar = function () {
      var sel = ops.filter(function (o) { return o.checked; });
      var items = [base + ':1'], total = +box.dataset.basePrice;
      var mej = sel.filter(function (o) { return o.dataset.reemplaza; })[0];
      if (mej) { items = [mej.value + ':1']; total = +mej.dataset.price; }
      else if (combo && ops.length > 1 && sel.length === ops.length) { items.push(combo + ':1'); total += +box.dataset.comboPrice; }
      else sel.forEach(function (o) { items.push(o.value + ':1'); total += +o.dataset.price; });
      if (comboEl) comboEl.hidden = !(combo && ops.length > 1 && sel.length === ops.length);
      totalEl.textContent = fmt(total);
      ir.href = '/cart/' + items.join(',') + query;
      solo.href = '/cart/' + base + ':1' + query;
    };
    var abrir = function (href, origen) {
      var q = href.indexOf('?'); query = q > -1 ? href.slice(q) : '';
      ultimo = origen; armar();
      box.hidden = false; document.documentElement.classList.add('pq-bump-abierto');
      setTimeout(function () { (ops[0] || ir).focus(); }, 50);
    };
    var cerrar = function () {
      box.hidden = true; document.documentElement.classList.remove('pq-bump-abierto');
      if (ultimo) ultimo.focus();
    };
    ops.forEach(function (o) { o.addEventListener('change', armar); });
    [].forEach.call(box.querySelectorAll('[data-pq-bump-cerrar]'), function (b) { b.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) cerrar(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || box.contains(a)) return;
      var h = a.getAttribute('href') || '';
      if (h.indexOf('/cart/' + base + ':') === -1 || h.indexOf(',') > -1) return;
      e.preventDefault();
      abrir(h, a);
    }, true);
  }

  // v22: las tarjetas de las mejores secciones aparecen suave al llegar (el texto queda fijo, como pidió Joaquín)
  function initCardsIn() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pq-card-ok'); obs.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.pq-kp__card, .pq-ok__card, .pq-ops__card, .pq-op, .pq-bono, .pq-garantia__box').forEach(function (el, i) { if (el.dataset.pqCi) return; el.dataset.pqCi = '1'; el.classList.add('pq-card-in'); el.style.transitionDelay = (i % 3) * 0.08 + 's'; obs.observe(el); });
  }
  // Pago externo (Impultienda): le pasa al checkout el fbclid y las utm del anuncio, para que Meta atribuya la compra
  function initPagoExterno() {
    var q = new URLSearchParams(location.search), extra = new URLSearchParams();
    ['fbclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { if (q.get(k)) extra.set(k, q.get(k)); });
    if (!extra.get('fbclid')) { var m = document.cookie.match(/(?:^|; )_fbc=fb\.\d+\.\d+\.([^;]+)/); if (m) extra.set('fbclid', decodeURIComponent(m[1])); }
    if (!extra.toString()) return;
    document.querySelectorAll('a[href*="impultienda.ar"]').forEach(function (a) {
      if (a.dataset.pqExt) return; a.dataset.pqExt = '1';
      a.href += (a.href.indexOf('?') > -1 ? '&' : '?') + extra.toString();
    });
  }
  function initAll() { initRipple(); initBuybar(); initCalc(); initTracks(); initReveal(); initBgVideo(); initBump(); initCardsIn(); initPagoExterno(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
